module.exports = __webpack_public_path__ + "assets/img/undo.1f8c2758.svg";